/**
 * Sheet simple para motivo de anular/descartar liquidación.
 */
import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, TextInput, View } from 'react-native';
import { TicketSheet } from '../../shared/ticket/TicketSheet';
import { TicketButton } from '../../shared/ticket/TicketButton';
import { ticketControls } from '../../shared/ticket/ticketControls.styles';
import { ticketColors } from '../../shared/theme/ticketColors';
import { ticketText } from '../../shared/ticket/ticketText';
import { spacing } from '../../shared/theme/spacing';

export type SettlementReasonSheetProps = {
  visible: boolean;
  title: string;
  subtitle?: string;
  confirmLabel: string;
  defaultReason: string;
  busy?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
};

export function SettlementReasonSheet({
  visible,
  title,
  subtitle,
  confirmLabel,
  defaultReason,
  busy = false,
  onClose,
  onConfirm,
}: SettlementReasonSheetProps) {
  const [reason, setReason] = useState(defaultReason);

  useEffect(() => {
    if (visible) setReason(defaultReason);
  }, [visible, defaultReason]);

  const trimmed = reason.trim();
  const canConfirm = trimmed.length >= 4 && !busy;

  return (
    <TicketSheet
      visible={visible}
      title={title}
      subtitle={subtitle}
      onClose={onClose}
      fitContent
      footer={
        <View style={styles.actions}>
          <TicketButton label="Cancelar" variant="ghost" onPress={onClose} style={{ flex: 1 }} disabled={busy} />
          <TicketButton
            label={busy ? 'Procesando…' : confirmLabel}
            variant="danger"
            testID="commissions.settlement.reason.confirm"
            onPress={() => onConfirm(trimmed)}
            disabled={!canConfirm}
            style={{ flex: 1 }}
          />
        </View>
      }
    >
      <View style={styles.body}>
        <Text style={ticketText.body}>Motivo (mínimo 4 caracteres)</Text>
        <TextInput
          style={[ticketControls.input, styles.input]}
          value={reason}
          onChangeText={setReason}
          placeholder="Ej. anulación por error de período"
          placeholderTextColor={ticketColors.ink3}
          editable={!busy}
          testID="commissions.settlement.reason.input"
          multiline
        />
      </View>
    </TicketSheet>
  );
}

const styles = StyleSheet.create({
  body: { gap: spacing.sm, paddingBottom: spacing.sm },
  input: { minHeight: 72, textAlignVertical: 'top' },
  actions: { flexDirection: 'row', gap: spacing.sm },
});
